// extracted by mini-css-extract-plugin
export default {"grid":"grid---_uaUQ","colHead":"colHead---D4Der","rowHead":"rowHead---rxa0N"};